import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { GlobalModal } from "../../components/authModals";
import MainHeader from "../Main/MainHeader";
import Header from "../Main/Header";
import Footer from "../Main/Footer";
import { setUser } from "../../redux/slices/userSlice";
import getUser from "../../api/user";
import { useDispatch } from "react-redux";
const OpenLayout = () => {
  const [token] = useState(localStorage.getItem("token") || sessionStorage.getItem("token"));
  const dispatch = useDispatch();

  const getUserData = async () => {
    try {
      const user = await getUser();
      dispatch(setUser(user as any));
    } catch (error) {
      console.error("Error fetching user:", error);
    }
  };

  useEffect(() => {
    if (token) {
      getUserData();
    }
  }, [token, getUserData]);

  const isQr = useLocation().pathname === "/qr";
  const isResetPassword = useLocation().pathname === "/reset-password";
  return (
    <>
      <GlobalModal />
      {token ? <MainHeader /> : isResetPassword ? <></> : <Header />}
      <Outlet />
      {!isQr && !isResetPassword && <Footer />}
    </>
  );
};

export default OpenLayout;
